import React from 'react';
import EventLogs from '../MSVPages/EventLogs/EventLogsPage';
import GeneratedMessage from '../MSVPages/GeneratedMessage/GeneratedMessagePage';

export const routes = [
    {
        path: "/",
        exact: true,
        main: (props) => <EventLogs {...props} />
    },
    {
        path: "/EventLogs",
        exact: true,
        main: (props) => <EventLogs {...props} />
    },
    {
        path: "/CustomerMessages",
        exact: true,
        main: (props) => <GeneratedMessage {...props} />
    }
];